import { appAddIcon } from './add';
import { appArrowBackIcon } from './arrow-back';
import { appArrowBackOutlineIcon } from './arrow-back-outline';
import { appArrowDownIcon } from './arrow-down';
import { appArrowForwardIcon } from './arrow-forward';
import { appArrowLeftDisabledIcon } from './arrow-left-disabled';
import { appArrowLeftMoIcon } from './arrow-left-mo';
import { appArrowRightDisabledIcon } from './arrow-right-disabled';
import { appArrowRightMoIcon } from './arrow-right-mo';
import { appArrowUpIcon } from './arrow-up';
import { appAttachIcon } from './attach';
import { appBackIcon } from './back';
import { appBackRoundIcon } from './back-round';
import { appBattleBossIcon } from './BattleBoss';
import { appBirreteIcon } from './birrete';
import { appBonusIcon } from './bonus';
import { appCalculoMental0Icon } from './calculo_mental_0';
import { appCalculoMental1Icon } from './calculo_mental_1';
import { appCalculoMental2Icon } from './calculo_mental_2';
import { appCalculoMental3Icon } from './calculo_mental_3';
import { appCalendarIcon } from './calendar';
import { appCalendarCustomIcon } from './calendar-custom';
import { appCalendarPlanIcon } from './calendar-plan';
import { appChevronRightIcon } from './chevron-right';
import { appClassroomIcon } from './classroom';
import { appConfigIcon } from './config';
import { appConfigPurpleIcon } from './config-purple';
import { appConfigurationIcon } from './configuration';
import { appCreateIcon } from './create';
import { appCrossIconIcon } from './cross_icon';
import { appCurriculumIcon } from './curriculum';
import { appCustomActivityIcon } from './custom-activity';
import { appDeleteIcon } from './delete';
import { appDisabledLockedIcon } from './disabled-locked';
import { appDisableCircleIcon } from './disable-circle';
import { appDoneIcon } from './done';
import { appDownloadIcon } from './download';
import { appDragIcon } from './drag';
import { appEditIcon } from './edit';
import { appEjercicio0Icon } from './ejercicio_0';
import { appEjercicio1Icon } from './ejercicio_1';
import { appEjercicio2Icon } from './ejercicio_2';
import { appEjercicio3Icon } from './ejercicio_3';
import { appEmojiBadIcon } from './emoji-bad';
import { appEmojiBadColoredIcon } from './emoji-bad-colored';
import { appEmojiExcellentIcon } from './emoji-excellent';
import { appEmojiExcellentColoredIcon } from './emoji-excellent-colored';
import { appEmojiGoodIcon } from './emoji-good';
import { appEmojiGoodColoredIcon } from './emoji-good-colored';
import { appEmojiRegularIcon } from './emoji-regular';
import { appEmojiRegularColoredIcon } from './emoji-regular-colored';
import { appEmptyCalendarIcon } from './empty-calendar';
import { appEnterIcon } from './enter';
import { appEstrategiaPensamiento0Icon } from './estrategia_pensamiento_0';
import { appEstrategiaPensamiento1Icon } from './estrategia_pensamiento_1';
import { appEstrategiaPensamiento2Icon } from './estrategia_pensamiento_2';
import { appEstrategiaPensamiento3Icon } from './estrategia_pensamiento_3';
import { appEvalIcon } from './eval';
import { appEvaluationIcon } from './evaluation';
import { appEvaluationRubricsIcon } from './evaluation-rubrics';
import { appExcelIcon } from './excel';
import { appExitIcon } from './exit';
import { appExitCalificacionesIcon } from './exit_calificaciones';
import { appExportIcon } from './export';
import { appExportGrayIcon } from './export-gray';
import { appEyeOffIcon } from './eye-off';
import { appEyeOffNocercleIcon } from './eye-off-nocercle';
import { appGeogebraIcon } from './geogebra';
import { appGoogleClassroomIcon } from './google-classroom';
import { appGoogleClassroomDisabledIcon } from './google-classroom-disabled';
import { appGoogleDriveIcon } from './google-drive';
import { appGoogleDriveGrayIcon } from './google-drive-gray';
import { appHelpIcon } from './help';
import { appHelpOutlineIcon } from './help-outline';
import { appHomeIcon } from './home';
import { appHomePurpleIcon } from './home-purple';
import { appHouseIcon } from './house';
import { appIcoEyeOffIcon } from './ico-eye-off';
import { appIcoEyeOnIcon } from './ico-eye-on';
import { appIconDownloadIcon } from './icon-download';
import { appIconEditIcon } from './icon-edit';
import { appIconEyeIcon } from './icon-eye';
import { appIconEyeDisabledIcon } from './icon-eye-disabled';
import { appIconEyeNcIcon } from './icon-eye-nc';
import { appIconEyeOffIcon } from './icon-eye-off';
import { appIconEyeOffDisabledIcon } from './icon-eye-off-disabled';
import { appIconEyeOffNcIcon } from './icon-eye-off-nc';
import { appIconLockedIcon } from './icon-locked';
import { appIconRefreshIcon } from './icon-refresh';
import { appIconRotateCwIcon } from './icon-rotate-cw';
import { appIconRotateCwDisabledIcon } from './icon-rotate-cw-disabled';
import { appIconUploadIcon } from './icon-upload';
import { appIconUserPlusIcon } from './icon-user-plus';
import { appIconUserPlusLeftIcon } from './icon-user-plus-left';
import { appIcAttachIcon } from './ic_attach';
import { appIcUserIcon } from './ic_user';
import { appImportIcon } from './import';
import { appImportZeroIcon } from './import-zero';
import { appInfoIcon } from './Info';
import { appInfoPurpleIcon } from './info-purple';
import { appInitialTestsIcon } from './initial-tests';
import { appInvestigacion0Icon } from './investigacion_0';
import { appInvestigacion1Icon } from './investigacion_1';
import { appInvestigacion2Icon } from './investigacion_2';
import { appInvestigacion3Icon } from './investigacion_3';
import { appJpgIcon } from './jpg';
import { appJuegoDemostracion0Icon } from './juego_demostracion_0';
import { appJuegoDemostracion1Icon } from './juego_demostracion_1';
import { appJuegoDemostracion2Icon } from './juego_demostracion_2';
import { appJuegoDemostracion3Icon } from './juego_demostracion_3';
import { appLessIcon } from './Less';
import { appLinkIcon } from './link';
import { appLogoutIcon } from './logout';
import { appLogoOnmatIcon } from './Logo_ONMAT';
import { appLogoOnmatWhiteIcon } from './Logo_ONMAT_white';
import { appLudificationIcon } from './ludification';
import { appMaharaIcon } from './mahara';
import { appMailIcon } from './mail';
import { appManipulativa0Icon } from './manipulativa_0';
import { appManipulativa1Icon } from './manipulativa_1';
import { appManipulativa2Icon } from './manipulativa_2';
import { appManipulativa3Icon } from './manipulativa_3';
import { appMapaMental0Icon } from './mapa_mental_0';
import { appMapaMental1Icon } from './mapa_mental_1';
import { appMapaMental2Icon } from './mapa_mental_2';
import { appMapaMental3Icon } from './mapa_mental_3';
import { appMaterialIcon } from './Material';
import { appMaterialPurpleIcon } from './material-purple';
import { appMicrosoftTeamsIcon } from './microsoft-teams';
import { appMindmupIcon } from './mindmup';
import { appOptionsIcon } from './Options';
import { appOptions2Icon } from './options_2';
import { appPbl0Icon } from './pbl_0';
import { appPbl1Icon } from './pbl_1';
import { appPbl2Icon } from './pbl_2';
import { appPbl3Icon } from './pbl_3';
import { appPdfIcon } from './pdf';
import { appPlayIcon } from './play';
import { appPlusIcon } from './plus';
import { appPowerPointIcon } from './power-point';
import { appPrintIcon } from './print';
import { appProgrammingPlanificationIcon } from './programming-planification';
import { appPublishIcon } from './publish';
import { appRecursoTeoricoIcon } from './recurso_teorico';
import { appRemindIcon } from './remind';
import { appRutinaPensamiento0Icon } from './rutina_pensamiento_0';
import { appRutinaPensamiento1Icon } from './rutina_pensamiento_1';
import { appRutinaPensamiento2Icon } from './rutina_pensamiento_2';
import { appRutinaPensamiento3Icon } from './rutina_pensamiento_3';
import { appScheduleIcon } from './schedule';
import { appScheduleCustomizeIcon } from './schedule-customize';
import { appSendIcon } from './send';
import { appSliderLeftIcon } from './slider-left';
import { appSliderRightIcon } from './slider-right';
import { appSmileIcon } from './smile';
import { appSolutionaryIcon } from './solutionary';
import { appStarIcon } from './star';
import { appStarPurpleIcon } from './star-purple';
import { appStrategiesIcon } from './strategies';
import { appStepMenuIcon } from './step_menu';
import { appStudentBookIcon } from './student-book';
import { appStudentsGroupIcon } from './students-group';
import { appStudentsGroupActivatedIcon } from './students-group-activated';
import { appSubtractIcon } from './subtract';
import { appTeacherIcon } from './teacher';
import { appTeacherGuideIcon } from './teacher-guide';
import { appThreeDotsIcon } from './three_dots';
import { appTrackingIcon } from './tracking';
import { appTrainingIcon } from './training';
import { appTrashIcon } from './trash';
import { appUnknownIcon } from './unknown';
import { appUnpublishIcon } from './unpublish';
import { appWarningIcon } from './warning';
import { appWordIcon } from './word';
import { appOrderIcon } from './order';
import { appMicrosoftTeamsDisabledIcon } from './microsoft-teams-disabled';
import { appExcelMaterialsIcon } from './excel-materials';
import { appImageMaterialsIcon } from './image-materials';
import { appPdfMaterialsIcon } from './pdf-materials';
import { appWordMaterialsIcon } from './word-materials';
import { appIconNotebookIcon } from './icon-notebook';
import { appIconNotebookCircleIcon } from './icon-notebook-circle';
import { appPresentationIcon } from './presentation';
import { appPresentationCircleIcon } from './presentation-circle';
import { appPrintGreyIcon } from './print-grey';
import { appClassImportedIcon } from './class-imported';
import { appBirreteWhiteIcon } from './birrete-white';
import { appChatIcon } from './chat';
import { appHelpBlackIcon } from './help-black';
import { appHelpPurpleIcon } from './help-purple';
import { appIconRotateWhiteIcon } from './icon-rotate-white';
import { appPauseIcon } from './pause';
import { appPlayNoCircleIcon } from './play-no-circle';
import { appAlarmOffIcon } from './alarm-off';
import { appAlarmOnIcon } from './alarm-on';
import { appPresentationWhiteIcon } from './presentation-white';
import { appPlayDisabledIcon } from './play-disabled';
import { appIconRestartIcon } from './icon-restart';
import { appGraphicIcon } from './graphic';
import { appCheckIcon } from './check';
import { appCheckCircle } from './check-circle';
import { appCurrentStepFilledIcon } from './current-step-filled';
import { appCurrentStepEmptyIcon } from './current-step-empty';
import { appArrowUpWhiteIcon } from './arrow-up-white';
import { appArrowDownWhiteIcon } from './arrow-down-white';
import { appIconEyeOffNewIcon } from './icon-eye-off-new';
import { appIconEyeNewIcon } from './icon-eye-new';
import { appFamilyIcon } from './families';
import { appGroupIcon } from './group';
import { appLogoThinkoaiNegativeIcon } from './logo_thinkoai_negativo';
import { appButtonIA } from './button_ia';
import { appSaveIcon } from './save';
import { appTableOrder } from './table-order';
import { appDocumentIcon } from './document';
import { appIconInfoIcon } from './icon-info';
import { appCheckCircleFilledIcon } from './check-circle-filled';
import { appHalfCircleIcon } from './half-circle';
import { appEmptyCircleIcon } from './empty-circle';
import { appCircleFilledIcon } from './circle-filled';
import { appSearchIcon } from './search';

export const svgIcons = [
  appAddIcon,
  appAlarmOffIcon,
  appAlarmOnIcon,
  appArrowBackOutlineIcon,
  appArrowBackIcon,
  appArrowDownIcon,
  appArrowDownWhiteIcon,
  appArrowForwardIcon,
  appArrowLeftDisabledIcon,
  appArrowLeftMoIcon,
  appArrowRightDisabledIcon,
  appArrowRightMoIcon,
  appArrowUpIcon,
  appArrowUpWhiteIcon,
  appAttachIcon,
  appBackRoundIcon,
  appBackIcon,
  appBattleBossIcon,
  appBirreteIcon,
  appBirreteWhiteIcon,
  appButtonIA,
  appBonusIcon,
  appCalculoMental1Icon,
  appCalculoMental2Icon,
  appCalculoMental3Icon,
  appCalendarCustomIcon,
  appCalendarPlanIcon,
  appCalendarIcon,
  appChevronRightIcon,
  appClassroomIcon,
  appCalculoMental0Icon,
  appChatIcon,
  appCurrentStepFilledIcon,
  appCurrentStepEmptyIcon,
  appCheckIcon,
  appCheckCircle,
  appClassImportedIcon,
  appConfigPurpleIcon,
  appConfigIcon,
  appConfigurationIcon,
  appCreateIcon,
  appCrossIconIcon,
  appCurriculumIcon,
  appCustomActivityIcon,
  appDeleteIcon,
  appDisabledLockedIcon,
  appDisableCircleIcon,
  appDoneIcon,
  appDownloadIcon,
  appDragIcon,
  appEditIcon,
  appEjercicio0Icon,
  appEjercicio1Icon,
  appEjercicio2Icon,
  appEjercicio3Icon,
  appEmojiBadColoredIcon,
  appEmojiBadIcon,
  appEmojiExcellentColoredIcon,
  appEmojiExcellentIcon,
  appEmojiGoodColoredIcon,
  appEmojiGoodIcon,
  appEmojiRegularColoredIcon,
  appEmojiRegularIcon,
  appEmptyCalendarIcon,
  appExportIcon,
  appEstrategiaPensamiento0Icon,
  appEstrategiaPensamiento1Icon,
  appEstrategiaPensamiento2Icon,
  appEstrategiaPensamiento3Icon,
  appEvalIcon,
  appEvaluationIcon,
  appEvaluationRubricsIcon,
  appExcelIcon,
  appExitIcon,
  appExitCalificacionesIcon,
  appEyeOffNocercleIcon,
  appEyeOffIcon,
  appExcelMaterialsIcon,
  appExportGrayIcon,
  appGeogebraIcon,
  appGoogleClassroomIcon,
  appGoogleClassroomDisabledIcon,
  appGoogleDriveGrayIcon,
  appGoogleDriveIcon,
  appGraphicIcon,
  appHelpOutlineIcon,
  appHelpBlackIcon,
  appHelpIcon,
  appHelpPurpleIcon,
  appHomePurpleIcon,
  appHomeIcon,
  appHouseIcon,
  appIcAttachIcon,
  appIcUserIcon,
  appIcoEyeOffIcon,
  appIcoEyeOnIcon,
  appIconDownloadIcon,
  appIconEditIcon,
  appImageMaterialsIcon,
  appEnterIcon,
  appIconEyeDisabledIcon,
  appIconEyeNcIcon,
  appIconEyeNewIcon,
  appIconEyeOffNewIcon,
  appIconEyeOffDisabledIcon,
  appIconEyeOffNcIcon,
  appIconEyeOffIcon,
  appIconEyeIcon,
  appIconLockedIcon,
  appIconNotebookIcon,
  appIconNotebookCircleIcon,
  appIconRefreshIcon,
  appIconRotateCwIcon,
  appIconRotateCwDisabledIcon,
  appIconRotateWhiteIcon,
  appIconUploadIcon,
  appIconUserPlusIcon,
  appIconUserPlusLeftIcon,
  appImportIcon,
  appPauseIcon,
  appPlayNoCircleIcon,
  appPresentationIcon,
  appPresentationCircleIcon,
  appImportZeroIcon,
  appInfoPurpleIcon,
  appInfoIcon,
  appInitialTestsIcon,
  appInvestigacion0Icon,
  appInvestigacion1Icon,
  appInvestigacion2Icon,
  appInvestigacion3Icon,
  appJpgIcon,
  appJuegoDemostracion0Icon,
  appJuegoDemostracion1Icon,
  appJuegoDemostracion2Icon,
  appJuegoDemostracion3Icon,
  appLessIcon,
  appLinkIcon,
  appLogoOnmatWhiteIcon,
  appLogoOnmatIcon,
  appLogoutIcon,
  appLudificationIcon,
  appMaharaIcon,
  appMailIcon,
  appManipulativa0Icon,
  appManipulativa1Icon,
  appManipulativa2Icon,
  appManipulativa3Icon,
  appMapaMental0Icon,
  appMapaMental1Icon,
  appMapaMental2Icon,
  appMapaMental3Icon,
  appMaterialPurpleIcon,
  appMaterialIcon,
  appMicrosoftTeamsIcon,
  appMicrosoftTeamsDisabledIcon,
  appMindmupIcon,
  appOptionsIcon,
  appOptions2Icon,
  appOrderIcon,
  appPbl0Icon,
  appPbl1Icon,
  appPbl2Icon,
  appPbl3Icon,
  appPdfIcon,
  appPdfMaterialsIcon,
  appPlayDisabledIcon,
  appPlayIcon,
  appPlusIcon,
  appPowerPointIcon,
  appPresentationWhiteIcon,
  appPrintIcon,
  appPrintGreyIcon,
  appFamilyIcon,
  appProgrammingPlanificationIcon,
  appPublishIcon,
  appRecursoTeoricoIcon,
  appRemindIcon,
  appIconRestartIcon,
  appRutinaPensamiento0Icon,
  appRutinaPensamiento1Icon,
  appRutinaPensamiento2Icon,
  appRutinaPensamiento3Icon,
  appScheduleCustomizeIcon,
  appScheduleIcon,
  appSendIcon,
  appSliderLeftIcon,
  appSliderRightIcon,
  appSmileIcon,
  appSolutionaryIcon,
  appStarPurpleIcon,
  appStarIcon,
  appStrategiesIcon,
  appStepMenuIcon,
  appStudentBookIcon,
  appStudentsGroupIcon,
  appStudentsGroupActivatedIcon,
  appSubtractIcon,
  appTeacherGuideIcon,
  appTeacherIcon,
  appTrackingIcon,
  appTrainingIcon,
  appTrashIcon,
  appThreeDotsIcon,
  appUnknownIcon,
  appUnpublishIcon,
  appWarningIcon,
  appWordIcon,
  appWordMaterialsIcon,
  appGroupIcon,
  appLogoThinkoaiNegativeIcon,
  appSaveIcon,
  appTableOrder,
  appDocumentIcon,
  appIconInfoIcon,
  appCheckCircleFilledIcon,
  appHalfCircleIcon,
  appEmptyCircleIcon,
  appCircleFilledIcon,
  appSearchIcon,
];
